'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { motion } from 'motion/react';
import { Button } from '@/components/ui/button';
const FormMotion = motion.create('div');
export function WelcomeForm({ onSubmit }) {
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    //  CARGAR DE LOCALSTORAGE AL ENTRAR
    useEffect(() => {
        const savedNombre = localStorage.getItem('xania_nombre');
        const savedCorreo = localStorage.getItem('xania_correo');
        const savedTelefono = localStorage.getItem('xania_telefono');
        if (savedNombre)
            setNombre(savedNombre);
        if (savedCorreo)
            setCorreo(savedCorreo);
        if (savedTelefono)
            setTelefono(savedTelefono);
    }, []);
    //  GUARDAR AUTOMÁTICAMENTE
    useEffect(() => {
        localStorage.setItem('xania_nombre', nombre);
        localStorage.setItem('xania_correo', correo);
        localStorage.setItem('xania_telefono', telefono);
    }, [nombre, correo, telefono]);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!nombre.trim() || !correo.trim() || !telefono.trim()) {
            alert('Por favor completa todos los campos');
            return;
        }
        if (!correo.includes('@')) {
            alert('Por favor ingresa un correo válido');
            return;
        }
        // ✅ También puedes asegurar persistencia aquí (por seguridad)
        localStorage.setItem('xania_nombre', nombre);
        localStorage.setItem('xania_correo', correo);
        localStorage.setItem('xania_telefono', telefono);
        onSubmit({ nombre, correo, telefono });
    };
    return (_jsx(FormMotion, { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0, y: -20 }, transition: { duration: 0.3 }, className: "flex h-full w-full flex-col items-center justify-center p-6 bg-white/95 dark:bg-[#111]/90 backdrop-blur-xl rounded-[28px]", children: _jsxs("form", { onSubmit: handleSubmit, className: "w-full max-w-sm space-y-6", children: [_jsxs("div", { className: "space-y-4 text-center", children: [_jsx("div", { className: "flex justify-center", children: _jsx("img", { src: "https://restaurantic.es/assets/img/restaurantic_llamas.webp", alt: "Restaurantic", width: 64, height: 64, className: "object-contain" }) }), _jsxs("div", { className: "space-y-2", children: [_jsx("h3", { className: "text-fg0 text-2xl font-bold", children: "\u00A1Hola! Soy Xania" }), _jsx("p", { className: "text-fg1 text-base font-medium", children: "T\u00FA asistente virtual" }), _jsx("p", { className: "text-fg2 text-sm", children: "Para comenzar, necesitamos algunos datos" })] })] }), _jsxs("div", { className: "space-y-4", children: [_jsx("input", { type: "text", value: nombre, onChange: (e) => setNombre(e.target.value), placeholder: "Tu nombre", required: true, className: "bg-bg2 text-fg0 w-full rounded-xl border-2 px-4 py-3 text-sm" }), _jsx("input", { type: "email", value: correo, onChange: (e) => setCorreo(e.target.value), placeholder: "Tu correo electr\u00F3nico", required: true, className: "bg-bg2 text-fg0 w-full rounded-xl border-2 px-4 py-3 text-sm" }), _jsx("input", { type: "tel", value: telefono, onChange: (e) => setTelefono(e.target.value), placeholder: "Tu tel\u00E9fono", required: true, className: "bg-bg2 text-fg0 w-full rounded-xl border-2 px-4 py-3 text-sm" })] }), _jsx(Button, { type: "submit", className: "w-full rounded-xl py-6 text-base font-semibold shadow-lg transition-all hover:scale-[1.02]", children: "Iniciar conversaci\u00F3n" })] }) }));
}
